module.exports = __webpack_public_path__ + "static/media/why-choose-img1.5ecc8b90.jpg";